import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import PlaylistPlayIcon from '@material-ui/icons/PlaylistPlay';
import Tooltip from '@material-ui/core/Tooltip';
import { makeStyles } from '@material-ui/core/styles';
import SectionTab from 'constants/SectionTab';
import container from './EpisodeListIcon.container';
import { scrollToMainContent } from 'common/ui/utils';

const useStyles = makeStyles((theme) => ({
  iconButton: {
    width: 30,
    height: 30,
    padding: 0,
    left: -10,
    display: 'inline-block'
  },
  icon: {
    display: 'inline-block',
    color: 'rgb(37, 37, 37)',
    fill: '#fff',
    userSelect: 'none',
    transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
    [theme.breakpoints.up('sm')]: {
      marginTop: 14,
      '&:hover': {
        color: theme.palette.iconHover,
        fill: theme.palette.iconHover
      }
    }
  },
  spanText: {
    fontFamily: 'Arial',
    paddingLeft: 2,
    fontSize: 12,
    verticalAlign: 'bottom',
    display: 'inline',
    color: 'rgb(176, 176, 176)'
  }
}));

const EpisodeListIcon = (props) => {
  const classes = useStyles();

  const {
    playerPodCastState: { podcastid },
    podcastPlaylistState: { currentPodcastId },
    onSetCurrentTab,
    onViewPodCastStart,
    // onFetchPodCastEpisode,
    onSetCurrentViewdPodPlaylist
  } = props;

  const onClickHandler = () => {
    onSetCurrentTab(SectionTab.PodCastDetail);
    onViewPodCastStart(podcastid);
    onSetCurrentViewdPodPlaylist(currentPodcastId);
    // onFetchPodCastEpisode(podcastid);
    scrollToMainContent();
  };

  return (
    <Tooltip title={'Episode List'}>
      <IconButton className={classes.iconButton} onClick={onClickHandler}>
        <PlaylistPlayIcon className={classes.icon} style={props.style} />
      </IconButton>
    </Tooltip>
  );
};

export default container(EpisodeListIcon);
